/* unplugin-vue-components disabled */import { render } from "./mega-menu-navigation.vue?vue&type=template&id=21c8e505"
import script from "./mega-menu-navigation.vue?vue&type=script&lang=js"
export * from "./mega-menu-navigation.vue?vue&type=script&lang=js"

import "./mega-menu-navigation.vue?vue&type=style&index=0&id=21c8e505&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__